import { withStyles, Grid } from '@material-ui/core';
import KpiInfo from './KpiInfo';
import RouteCompliance from './RouteCompliance';
import { getTimeString } from '../../Utils';

const styles = (theme) => ({
  container: {
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 8,
    marginBottom: 24,
    padding: 12
  },
  header: {
    color: theme.gridTextColor,
    textAlign: 'center',
    fontSize: '18px',
    fontWeight: 400
  },
  label: {
    color: theme.gridTextColor,
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: 600
  },
  noCompliance: {
    color: theme.iconColor,
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 400,
    padding: 28
  },
  compliance: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'grid'
  }
});

const RouteKPI = ({ route, classes }) => {
  return (
    <Grid container direction="column" className={classes.container}>
      <Grid container spacing={24}>
        <Grid item xs={8} className={classes.compliance}>
          {route.isLiveDispatch ? (
            <>
              <div className={classes.noCompliance}>
                Route compliance will be available once the route is complete.
              </div>
              <div className={classes.header}>Route Compliance</div>
            </>
          ) : (
            <>
              <RouteCompliance percentage={route?.compliancePercentage} />
              <div className={classes.header}>Route Compliance</div>
              <div className={classes.label}>{`${
                route?.deviationCount || 0
              } Optimization Deviation`}</div>
            </>
          )}
        </Grid>
        <Grid item xs={4}>
          <KpiInfo value={getTimeString(route?.gateOutTime)} name="Gate-out" />
          <KpiInfo value={getTimeString(route?.arriveAtTerminalTime)} name="Gate-in" />
          <KpiInfo value={route?.missedApts} name="Missed Appts" />
        </Grid>
        <Grid item container>
          <Grid item container xs={8}>
            <Grid item xs={4}>
              <KpiInfo value={route?.stops.length || 0} name="Total Stops" withBorder />
            </Grid>
            <Grid item xs={4}>
              <KpiInfo value={route?.totalBills} name="Total Bills" withBorder />
            </Grid>
            <Grid item xs={4}>
              <KpiInfo
                value={route.isLiveDispatch ? route?.plannedTotalMiles : route?.totalMiles}
                name="Total Miles"
                withBorder
                showPlannedIcon={route.isLiveDispatch}
              />
            </Grid>
          </Grid>
          <Grid item xs={4}>
            <KpiInfo
              value={route.isLiveDispatch ? route?.plannedTotalTime : route?.totalTime}
              name="Total Time"
              withBorder
              isTimeString
              showPlannedIcon={route.isLiveDispatch}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(RouteKPI);
